export const APPLE_AUTH_KEYS = {
  state: 'apple_login_state',
  nonce: 'apple_login_nonce',
} as const;

type AppleAuthorizeOptions = {
  clientId: string;
  redirectUri: string;
  state: string;
  nonce: string;
  scope?: string;
  responseType?: 'code' | 'code id_token';
  responseMode?: 'form_post' | 'query' | 'fragment';
};

const APPLE_AUTHORIZE_URL = 'https://appleid.apple.com/auth/authorize';

const toBase64Url = (bytes: Uint8Array) => {
  let base64 = '';
  if (typeof window !== 'undefined' && typeof btoa === 'function') {
    const binary = String.fromCharCode(...bytes);
    base64 = btoa(binary);
  } else if (typeof Buffer !== 'undefined') {
    base64 = Buffer.from(bytes).toString('base64');
  }
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

export const createAppleAuthToken = (length = 32) => {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return toBase64Url(bytes);
};

export const buildAppleAuthorizeUrl = ({
  clientId,
  redirectUri,
  state,
  nonce,
  scope = 'name email',
  responseType = 'code',
  responseMode = 'form_post',
}: AppleAuthorizeOptions) => {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: responseType,
    response_mode: responseMode,
    scope,
    state,
    nonce,
  });
  return `${APPLE_AUTHORIZE_URL}?${params.toString()}`;
};

export const setAppleAuthValue = (
  key: (typeof APPLE_AUTH_KEYS)[keyof typeof APPLE_AUTH_KEYS],
  value: string,
) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(key, value);
};

export const getAppleAuthValue = (
  key: (typeof APPLE_AUTH_KEYS)[keyof typeof APPLE_AUTH_KEYS],
) => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(key);
};

export const clearAppleAuthValues = () => {
  if (typeof window === 'undefined') return;
  Object.values(APPLE_AUTH_KEYS).forEach((key) => {
    window.sessionStorage.removeItem(key);
  });
};
